import React from 'react';
import { connect } from 'react-redux';
import { modalActions } from '../../../redux/root-action';
import styled from 'styled-components';
import Button from "../../Shared/Button";
//import { keyDown } from '../../utils/helpers';

const StyledFooter = styled.div<{ customStyles: string }>`
  &&& {
    ${props => props.customStyles}
  }
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 32px;
  @media only screen and (max-width: 767px) {
    box-shadow: none;
    height: auto;
  }
  @media only screen and (max-width: 480px) {
    padding: 0;
    flex-direction: ${({isAllSetModal}) => isAllSetModal && "column-reverse"};
  }
`;

const StyledPrimaryButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  @media only screen and (max-width: 480px) {
    justify-content: center;
    width: ${({isAllSetModal}) => isAllSetModal && "100%"};
  }
`;
const StyledTertiaryButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  font-family: var(--beacon-font-families-nimbus-sans-novus);
  font-weight: var(--beacon-font-weight-bold);
  margin-right: 32px;
  @media only screen and (max-width: 480px) {
    margin-right: ${({isAllSetModal}) => isAllSetModal && "0px"};
    margin-top: ${({isAllSetModal}) => isAllSetModal && "15px"};
  }
`;


class ReactModalFooter extends React.Component<any, any> {

  render(): any {
    const {
      handleOnClick,
      closeModal,
      tertiaryButtonText,
      primaryButtonText,
      cancelButtonText,
      cancelButtonType,
      buttonType,
      handleCancelClick,
      children,
      hideCancel = false,
      customStyles,
      disabled,
      primaryButtonDisabled,
      primaryButtonId,
      tertiaryButtonId,
      isAllSetModal
    } = this.props;
    const mq = window.matchMedia('(max-width: 767px)');
    return (
        <StyledFooter
            id={`modal-footer`}
            customStyles={customStyles}
            isAllSetModal={isAllSetModal}
        >

          {tertiaryButtonText && (
              <StyledTertiaryButtonContainer isAllSetModal={isAllSetModal}>
                <Button
                    variant="tertiary"
                    tabIndex={0}
                    buttonTitle={tertiaryButtonText}
                    onBeaconClick={handleCancelClick}
                    disabled={disabled}
                    id={tertiaryButtonId}

                />
              </StyledTertiaryButtonContainer>
          )}
          {primaryButtonText && (
              <StyledPrimaryButtonContainer isAllSetModal={isAllSetModal}>
                <Button
                    tabIndex={1}
                    buttonTitle={primaryButtonText}
                    onBeaconClick={handleOnClick}
                    disabled={primaryButtonDisabled}
                    id={primaryButtonId}
                />
              </StyledPrimaryButtonContainer>
          )}
          {!mq.matches && children}
        </StyledFooter>
    );
  }
}

export default connect(null, {
  closeModal: modalActions.closeModal,
})(ReactModalFooter);
